<template>
  <page>
    <v-tabs v-model="tab" :show-arrows="$vuetify.breakpoint.smAndDown">
      <v-tab>Основная информация</v-tab>
      <v-tab>Идентификаторы</v-tab>
      <v-tab>
        Управление доступом
      </v-tab>
      <v-tab>
        События СКУД
      </v-tab>
      <v-tab>
        Лог. событий
      </v-tab>
      <v-tab v-if="enableRating">
        Рейтинг
      </v-tab>
      <v-tab v-if="enablePersonalArea">
        Личный кабинет
      </v-tab>
      <v-tab v-if="enableTags">
        Метки
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item class="py-4">
        <general-information
          v-if="Object.keys(user).length"
          :user="user"
          :category-list="categoryList"
          :user-management="userManagement"
        />
      </v-tab-item>

      <v-tab-item class="pa-4">
        <identifiers-information
          v-if="Object.keys(user).length"
          :identifiers="user.identifiers"
          :operations="operations"
          @update="loadData"
        />
      </v-tab-item>

      <v-tab-item class="py-4">
        <access-information
          v-if="Object.keys(user).length"
          :user="user"
          :category-list="categoryList"
        />
      </v-tab-item>

      <v-tab-item class="py-4">
        <access-event-information :userId="this.userId" />
      </v-tab-item>

      <v-tab-item class="py-4">
        <event-log :userId="this.userId" />
      </v-tab-item>

      <v-tab-item v-if="enablePersonalArea" class="py-4">
        <user-lk v-if="Object.keys(user).length" :user="user" />
      </v-tab-item>

      <v-tab-item v-if="enableRating" class="py-4">
        <rating-information :userId="this.userId" />
      </v-tab-item>

      <v-tab-item v-if="enableTags" class="py-4">
        <user-tags v-if="Object.keys(user).length" :user="user" />
      </v-tab-item>
    </v-tabs-items>
  </page>
</template>

<script>
import {
  getAcsEvent,
  getUserById,
  getUserIdentifierOperation,
  getUserManagement
} from "../../services/user.service";

import { getCategoryList } from "../../services/category.service";
import { session } from "@/services/session.service";
import { isAvailableModule } from "@/services/systemConfig.service";

import Page from "../../components/Page";
import GeneralInformation from "../../components/user-management/UserInformation/GeneralInformation";
import IdentifiersInformation from "../../components/user-management/IdentifiersInformation/IdentifiersInformation";
import RatingInformation from "../../components/user-management/RatingInformation/RatingInformation.vue";
import AccessInformation from "@/components/user-management/AccessInformation/AccessInformation";
import AccessEventInformation from "@/components/user-management/AccessEventInformation";
import UserTags from "../../components/user-management/UserInformation/UserTags";
import UserLk from "../../components/user-management/UserLK/UserLk";
import EventLog from "@/views/EventLog";

export default {
  name: "UserEdit",
  components: {
    UserLk,
    EventLog,
    UserTags,
    AccessEventInformation,
    AccessInformation,
    IdentifiersInformation,
    GeneralInformation,
    RatingInformation,
    Page
  },

  data: () => ({
    tab: null,

    events: {},
    user: {},
    userId: null,

    userManagement: [],
    categoryList: [],
    operations: [],

    session: session
  }),

  computed: {
    eventLogTabIndex() {
      return 4;
    },

    eventsExist() {
      return this.events.content ? !this.events.content.length : true;
    },

    enablePersonalArea() {
      return isAvailableModule("personal-area");
    },

    enableTags() {
      return isAvailableModule("tags");
    },

    enableRating() {
      return (
        isAvailableModule("rating") &&
        this.user.groups &&
        this.user.groups.some(g => g.toUpperCase() === "ENTRANT") &&
        session.permission.isAllow("tabs", "rating_request")
      );
    }
  },

  created() {
    this.userId = this.$route.params.userId;
    this.getUserManagement();
    this.initTab();
  },

  async mounted() {
    await this.loadData();
    await this.getCategoryList();
  },

  watch: {
    tab(val) {
      if (val !== this.eventLogTabIndex) {
        this.$router.replace({ query: { tab: val } });
      } else {
        this.$router.replace({ query: { tab: "eventLog" } });
      }
    },

    "$route.params.id": {
      async handler() {
        await this.loadData();
      }
    }
  },

  methods: {
    initTab() {
      const queryTab = this.$route.query.tab;
      if (queryTab === "eventLog") {
        this.$nextTick(() => {
          this.tab = this.eventLogTabIndex;
        });
      } else {
        this.tab = Number(queryTab) || 0;
      }
    },

    async loadData() {
      const { userId } = this.$route.params;

      try {
        this.user = await getUserById(userId);
        this.operations = await getUserIdentifierOperation(userId);

        this.events = await getAcsEvent(userId);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async getUserManagement() {
      try {
        this.userManagement = await getUserManagement(
          this.$route.params.userId
        );
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async getCategoryList() {
      this.categoryList = [
        ...(await getCategoryList("PPS")),
        ...(await getCategoryList("STAFF")),
        ...(await getCategoryList("ENTRANT"))
      ];

      this.categoryList.sort((a, b) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      );
    }
  }
};
</script>
